import type {
  ReviewSubmissionEntryContext,
  TRecentPurchaseItem,
} from '@src/quince-components/src/atoms/reviews/reviewSubmission'
import { FEATURES, MODULES } from '@src/quince-site-common/src/constants/template-info'
import { captureException } from '@src/quince-site-common/src/utils/sentryUtil'
import { REVIEWS_SOURCES } from '@src/quince-site-pdp/src/organisms/productPageSections/productReviews/productReviews.constant'

export const CARD_MAX_THUMBNAILS = 3

export const APP_WEB_EVENTS = {
  REFRESH_RECENT_PURCHASES: 'REFRESH_RECENT_PURCHASES',
} as const

export const notifyAppOfModalState = (isModalOpened: boolean): void => {
  if (typeof window === 'undefined' || typeof window.ReactNativeWebView?.postMessage !== 'function') return
  try {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        // @i18n-ignore
        action: 'IS_MODAL_OPENED',
        payload: { isModalOpened },
      }),
    )
  } catch (error) {
    captureException(error, { module: MODULES.POST_ORDER_WEB, feature: FEATURES.ORDER_DETAILS })
  }
}

export const isRewardPointsBadgeShown = (rewardPoints: number): boolean => rewardPoints > 0

export const REVIEW_ENTRY_POINTS = {
  ORDERS_BANNER_IMAGE: 'orders_banner_image',
  ORDERS_BANNER_CTA: 'orders_banner_cta',
  PAST_PURCHASES_SHEET: 'past_purchases_sheet',
} as const

export const REVIEW_CLICK_DESTINATIONS = {
  PAST_PURCHASES_SHEET: 'past_purchases_sheet',
  REVIEW_FORM: 'review_form',
} as const

export const SHEET_DISMISS_METHODS = {
  MAYBE_LATER: 'maybe_later',
  CLOSE_ICON: 'close_icon',
} as const

export const variantLine = (item: TRecentPurchaseItem): string =>
  item.variantOptions.map(option => option.displayName || option.value).join(' | ')

export const toEntryContext = (item: TRecentPurchaseItem): ReviewSubmissionEntryContext => ({
  customerId: item.customerId != null ? String(item.customerId) : undefined,
  orderNumber: item.orderNumber != null ? String(item.orderNumber) : undefined,
  fulfillmentId: item.fulfillmentId != null ? String(item.fulfillmentId) : undefined,
  variantId: item.variantId != null ? String(item.variantId) : undefined,
  quinceProductId: item.quinceProductId != null ? String(item.quinceProductId) : undefined,
  author: item.author,
  source: REVIEWS_SOURCES.ORDER_LIST,
})

export const buildAppReviewSubmitUrl = (queryParams: Record<string, string | number | undefined | null>): string => {
  const params = new URLSearchParams()
  Object.entries(queryParams).forEach(([key, value]) => {
    if (value != null && String(value) !== '') params.set(key, String(value))
  })
  return `${window.location.origin}/reviews/submit?${params.toString()}`
}
